export const userColumns = [
  { field: "id", headerName: "ID", width: 120 },
  {
    field: "name",
    headerName: "Utilisateur",
    width: 250,

  },
  {
    field: "email",
    headerName: "Email",
    width: 260,
  },
  {
    field: "phone",
    headerName: "Telephone",
    width: 250,
  },


];

export const productsColumns = [
  { field: "id", headerName: "ID", width: 80 },
  {
    field: "name",
    headerName: "produits",
    width: 250,
    renderCell: (params) => {
      const imageUrl = `http://localhost:5000/${params.row.productImage.replace(/\\/g, '/')}`;
      return (
        <div className="cellWithImg">
          <img 
            className="cellImg" 
            src={imageUrl} 
            alt={params.row.name}
          />
          {params.row.name}
        </div>
      );
    },
  },
  
  {
    field: "category", 
    headerName: "Catégories",
    width: 220,
  },
  {
    field: "quantity",
    headerName: "Quantité",
    width: 200,
  },
  {
    field: "price",
    headerName: "Prix",
    width: 200,
  },


];

export const ordersColumns = [
  { field: "id", headerName: "ID", width: 120 },
  {
    field: "useremail",
    headerName: "Clients",
    width: 260,
  },
  {
    field: "createdAt",
    headerName: "Date",
    width: 250,

  },
  {
    field: "totalPrice",
    headerName: "Montant",
    width: 250,
  },


];

